import React from "react";
// import img1 from "../../Assest/ortho-png-logo.webp";
// import img2 from "../../Assest/1Point1-Logo.png";
// import img3 from "../../Assest/athenabpo.png";
// import img4 from "../../Assest/logo-42.webp";
// import img5 from "../../Assest/white-PhotoRoom.png-PhotoRoom.png";
import { FaAnglesRight } from "react-icons/fa6";

import { Helmet } from "react-helmet";
function Clientpage() {

  return (
    <div>
     <Helmet>
  <title>Our Valued Clients - Ayn Solutions</title>
  <meta
    name="description"
    content="Discover how Ayn Solutions supports your tech career with personalized career counseling, skill enhancement workshops, interview preparation, networking events, resume building, and job search support. Achieve your career success with our expert guidance."
  />
  <link rel="canonical" href="https://ayn-solutions.vercel.app/Client" />
</Helmet>


      <div

        className="bg-gradient-to-b from-black to-[#274584] h-[400px] overflow-hidden ">
        <div className="flex flex-col-reverse lg:flex-row justify-between lg:gap-2">
          <div

            className=" justify-center  lg:ps-10 flex flex-col gap-6">
            <h1 className="text-[#D1D5DB] text-center font-semibold font-[raleway] mt-5 lg:mt-0 text-2xl lg:text-start lg:text-4xl lg:w-[650px]">
              Elevate Your Career with Ayn Solutions            </h1>
            <p className="text-white mb-10 lg:mb-0 text-center lg:text-lg lg:text-start font-[poppins] text-sm lg:w-[750px] lg:ps-4 ">
              Our team of seasoned career advisors is committed to understanding your unique aspirations, strengths, and goals in the tech field. Through personalized consultations, we deliver tailored insights and guidance to empower you in making informed decisions about your career path in the ever-evolving tech landscape.
            </p>
          </div>

          <svg
            focusable="false"
            className="hero__honeycom lg:h-[370px] h-[120px] lg:w-[320px] "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 308.72 465.51"
          >
            <title>qti-inside-page-honeycomb-desktop</title>
            <path
              d="M245.36,34.33,185.9,0,126.44,34.33V103l59.46,34.33L245.36,103Z"
              fill="#fff"
            ></path>
            <path
              d="M182.1,143.68l-59.46-34.33L63.18,143.68v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M308.61,143.68l-59.46-34.33-59.46,34.33v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M118.92,253.2,59.46,218.87,0,253.2v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M245.46,253.2,186,218.87,126.54,253.2v68.66L186,356.19l59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M308.72,362.52l-59.46-34.33L189.8,362.52v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
          </svg>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-evenly items-center mt-10 px-4">
        <div className="flex flex-col justify-center items-center gap-4">
          <div className="flex flex-col justify-center items-center gap-3">
            <h1 className="font-bold text-xl">
              Our Services
            </h1>
            <div className="bg-[#478CCF] h-[2px] w-[200px]"></div>
          </div>
          <div>
            <p className="text-[raleway] font-semibold text-lg text-center">
              Elevate Your Career with Our Specialized Services
            </p>
            <ul className="text-gray-700 flex flex-col gap-5 mt-5">
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Resume Building: Craft a standout, professional resume that leaves a lasting impression.
              </li>
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Job Matching: Discover opportunities aligned with your skills and career goals.
              </li>
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Interview Mastery: Develop the confidence and skills to excel in job interviews.
              </li>
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Personalized Career Counseling: Get expert guidance tailored to your aspirations, strengths, and goals.
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center gap-4">
          <div className="flex flex-col justify-center items-center gap-3">
            <h1 className="font-bold text-xl">
              Seamless Journey to Success
            </h1>
            <div className="bg-[#478CCF] h-[2px] w-[200px]"></div>
          </div>
          <div>
            <p className="text-[raleway] font-semibold text-lg text-center">
              Transform Your Career with Our Simple Process
            </p>
            <ul className="text-gray-700 flex flex-col gap-5 mt-5">
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Reach Out: Contact us via email or phone to schedule an initial consultation.
              </li>
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Skills Assessment: We’ll assess your skills, goals, and career aspirations.
              </li>
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Personalized Plan: Receive a tailored plan designed to meet your unique needs.
              </li>
              <li className="flex gap-2 items-center">
                <FaAnglesRight className="text-[#478CCF]" /> Ongoing Support: Enjoy continuous guidance throughout your job search journey.
              </li>
            </ul>
          </div>
        </div>


      </div>
      <h1

        className="text-center text-3xl lg:text-4xl font-[poppins] mt-12">
        Navigating Career <span className="text-[#478CCF]">Success</span>
        Together
      </h1>
      <p

        className="text-gray-700 text-center mt-8 px-4 lg:px-36">
        Our team of experienced career counselors is dedicated to understanding your individual aspirations, strengths, and goals. Through personalized consultations, we provide insights and guidance tailored to your specific needs, helping you make informed decisions about your career path.
      </p>
      <div className=" flex items-center justify-evenly flex-col lg:flex-row gap-4 px-3 mt-5 flex-wrap pb-8">

        <div

          className="">
          <h1 className="text-2xl text-center text-gray-600 font-extralight font-[raleway]">
            Tech  {""}
            <span className="text-[#274584]  font-[poppins] font-semibold"> Professionals</span>
          </h1>
          <div className="flex  ms-10 gap-10 mt-5">
            <div className="h-[310px] md:h-[100px] lg:h-[180px] w-[2px] bg-[#274584] after:h-[10px] after:w-[10px] after:rounded-full relative after:absolute after:-left-[4px] after:-top-[5px] before:w-[10px] after:bg-[#274584] before:h-[10px] before:rounded-full before:bg-[#274584] before:absolute before:-left-[4px] before:-bottom-[5px]"></div>
            <div>
              <p className="lg:w-[400px] text-gray-700 font-[raleway] ">
                Our team of expert career advisors is dedicated to understanding your unique aspirations, strengths, and goals in the tech industry. Through tailored consultations, we offer personalized insights and guidance to help you make informed decisions about your career path, ensuring you achieve success in the ever-evolving tech landscape.
              </p>
            </div>
          </div>
        </div>
        <div

          className="">
          <h1 className="text-2xl text-center text-gray-600 font-extralight font-[raleway]">
            Skill Enhancement   {""}
            <span className="text-[#274584]  font-[poppins] font-semibold">Workshops</span>
          </h1>
          <div className="flex ms-10 gap-10 mt-5">
            <div className="h-[310px] md:h-[100px] lg:h-[180px] w-[2px] bg-[#274584] after:h-[10px] after:w-[10px] after:rounded-full relative after:absolute after:-left-[4px] after:-top-[5px] before:w-[10px] after:bg-[#274584] before:h-[10px] before:rounded-full before:bg-[#274584] before:absolute before:-left-[4px] before:-bottom-[5px]"></div>
            <div>
              <p className="lg:w-[400px] text-gray-700 font-[raleway] ">
                In today's dynamic job market, staying ahead requires continuous skill development. Our skill enhancement workshops cover a wide range of topics, from industry-specific tools and technologies to essential soft skills like communication and leadership. These sessions are designed to equip tech professionals with the competencies necessary for success in their chosen field.
              </p>
            </div>
          </div>
        </div>
        <div

          className="">
          <h1 className="text-2xl text-center text-gray-600 font-extralight font-[raleway]">
            Interview   {""}
            <span className="text-[#274584]  font-[poppins] font-semibold">Preparation</span>
          </h1>
          <div className="flex  ms-10 gap-10 mt-5">
            <div className="h-[310px] md:h-[100px] lg:h-[180px] w-[2px] bg-[#274584] after:h-[10px] after:w-[10px] after:rounded-full relative after:absolute after:-left-[4px] after:-top-[5px] before:w-[10px] after:bg-[#274584] before:h-[10px] before:rounded-full before:bg-[#274584] before:absolute before:-left-[4px] before:-bottom-[5px]"></div>
            <div>
              <p className="lg:w-[400px] text-gray-700 font-[raleway] ">
                Facing a tech interview can be a nerve-wracking experience. Our interview preparation services include mock interviews, personalized feedback sessions, and valuable tips to boost your confidence and enhance your performance during actual job interviews. We aim to transform interviews into opportunities for you to shine in the tech industry.
              </p>
            </div>
          </div>
        </div>
        <div className="">
          <h1 className="text-2xl text-center text-gray-600 font-extralight font-[raleway]">
            Networking Events and {""}
            <span className="text-[#274584]  font-[poppins] font-semibold">Communities</span>
          </h1>
          <div className="flex ms-10 gap-10 mt-5">
            <div className="h-[310px] md:h-[100px] lg:h-[180px] w-[2px] bg-[#274584] after:h-[10px] after:w-[10px] after:rounded-full relative after:absolute after:-left-[4px] after:-top-[5px] before:w-[10px] after:bg-[#274584] before:h-[10px] before:rounded-full before:bg-[#274584] before:absolute before:-left-[4px] before:-bottom-[5px]"></div>
            <div>
              <p className="lg:w-[400px] text-gray-700 font-[raleway] ">
                Unlock new career opportunities through our networking events and online communities. Connect with like-minded professionals, industry experts, and potential employers to build meaningful relationships that shape your career. Join our vibrant community to stay informed, connected, and empowered in your professional journey.
              </p>
            </div>
          </div>
        </div>

        <div className="">
          <h1 className="text-2xl text-center text-gray-600 font-extralight font-[raleway]">
            Resume Building and  {""}
            <span className="text-[#274584]  font-[poppins] font-semibold">Optimization</span>
          </h1>
          <div className="flex  ms-10 gap-10 mt-5">
            <div className="h-[310px] md:h-[100px] lg:h-[180px] w-[2px] bg-[#274584] after:h-[10px] after:w-[10px] after:rounded-full relative after:absolute after:-left-[4px] after:-top-[5px] before:w-[10px] after:bg-[#274584] before:h-[10px] before:rounded-full before:bg-[#274584] before:absolute before:-left-[4px] before:-bottom-[5px]"></div>
            <div>
              <p className="lg:w-[400px] text-gray-700 font-[raleway] ">
                Creating an impactful resume is essential for making a lasting first impression. Our experts work with you to develop a professional resume that highlights your accomplishments and showcases your potential. We also offer optimization services to ensure your resume aligns with modern recruitment requirements. Stand out in the competitive job market with a tailored, optimized resume that reflects your unique value proposition.
              </p>
            </div>
          </div>
        </div>

        <div className="">
          <h1 className="text-2xl text-center text-gray-600 font-extralight font-[raleway]">
            Job Search Guidance for Your Success  {""}
            <span className="text-[#274584]  font-[poppins] font-semibold">Support</span>
          </h1>
          <div className="flex ms-10 gap-10 mt-5">
            <div className="h-[310px] md:h-[100px] lg:h-[180px] w-[2px] bg-[#274584] after:h-[10px] after:w-[10px] after:rounded-full relative after:absolute after:-left-[4px] after:-top-[5px] before:w-[10px] after:bg-[#274584] before:h-[10px] before:rounded-full before:bg-[#274584] before:absolute before:-left-[4px] before:-bottom-[5px]"></div>
            <div>
              <p className="lg:w-[400px] text-gray-700 font-[raleway]">
                Navigating the dynamic job market can be challenging. At Ayn Solutions, our job search support goes beyond traditional methods. We offer personalized job matching, application assistance, and insights into emerging trends. Our goal is to streamline your search and enhance your chances of securing the perfect role. Trust us to be your partner in success.
              </p>

            </div>
          </div>
        </div>





      </div>

      {/* <h1 className='text-center text-3xl lg:text-4xl font-[poppins] font-semibold mt-10'>Our Clients</h1>
      <div

        className="bg-[#E3F6F9] mt-10 ">
        <div className="flex flex-col justify-center items-center  lg:flex-row lg:justify-evenly">
          <img alt="Ortho PNG" className="w-[200px] h-[150px] object-contain rounded" src={img1} data-robots="noindex" />
          <img alt="1Point1 Logo" className="w-[200px] h-[150px] object-contain" src={img2} data-robots="noindex" />
          <img alt="Athena BPO" className="w-[200px] h-[150px] object-contain rounded" src={img3} data-robots="noindex" />
          <img alt="Logo 42" className="w-[200px] h-[150px] object-contain rounded" src={img4} data-robots="noindex" />
          <img alt="White PhotoRoom" className="w-[200px] h-[150px] object-contain rounded" src={img5} data-robots="noindex" />
        </div>
      </div> */}

   





    </div>
  );
}

export default Clientpage;
